/**
 * Nest the form fields and custom fields by profile_id -> display_order.
 *
 * App configs can carry custom field entries (custom_fields.<name>) that have
 * no data_type or values. Those would render a second plain text input next to
 * the real custom field, so the custom field definition always wins.
 */
export function nestFormFields(formFields, customFields) {
  const fields = {};
  const add = (f) => {
    // Convert null to 0 for consistency
    const profileId = f.profile_id ?? 0;
    if (!fields[profileId]) {
      fields[profileId] = { [f.display_order]: [f] };
    } else if (!fields[profileId][f.display_order]) {
      fields[profileId][f.display_order] = [f];
    } else {
      fields[profileId][f.display_order].push(f);
    }
  };

  // Only built if the config has custom field entries, which is rare
  let customAttributes;
  for (const f of formFields ?? []) {
    if (f.attribute?.startsWith('custom_fields.')) {
      customAttributes ??= new Set(customFields.map((cf) => cf.attribute));
      if (customAttributes.has(f.attribute)) {
        continue;
      }
    }
    add(f);
  }
  for (const f of customFields) {
    add(f);
  }
  return fields;
}
